import styled from 'styled-components';
import { Modal } from 'ui';

export const StyledDeleteModal = styled(Modal)`
  .anticon-exclamation-circle {
    color: ${(props) => props.theme.darkRed};
  }

  .confirm-title {
    display: flex;
    flex-direction: row;
    gap: 10px;
    margin-top: 5px;
  }

  svg {
    height: 30px;
    width: 30px;
  }
`;
